import { render, staticRenderFns } from "./member_permissions.vue?vue&type=template&id=767c6614&"
import script from "./member_permissions.vue?vue&type=script&lang=js&"
export * from "./member_permissions.vue?vue&type=script&lang=js&"
import style0 from "./member_permissions.vue?vue&type=style&index=0&id=767c6614&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports